import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as spaceSurveyConfigurations from '../../survey-configurations'

export const RESOURCE = {
  payload: {
    description:
      'A scenario-scoped Space survey configuration record that stores survey setup state for the Space Survey Configuration experience.',
    dimension: spaceSurveyConfigurations.RESOURCE.payload,
    level: 0,
    name: 'Space Survey Config',
    partialId: PartialId.Standard.create('space_survey_config'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
